import { useVoiceCallArbitration } from '#features/voice/hooks/useVoiceCallArbitration';
import { VoiceWidget } from './index';

/**
 * Точка монтирования окна разговора — рядом с оверлеем звонков, в корне лейаута. Соединение обязано
 * жить выше роутера: при переходе между страницами окно не перемонтируется, и разговор не рвётся.
 *
 * Здесь же живёт арбитраж между личным звонком и голосом сессии: микрофон один, разговоров может
 * быть два. Подпись окна (игра, хозяин) приезжает не пропсами, а через стор в момент входа.
 */
export const VoiceWidgetHost = () => {
  useVoiceCallArbitration();

  return <VoiceWidget />;
};
